import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.scss','../../../../../../assets/sass/pages/page-users.scss']
})
export class ManageComponent implements OnInit {

  courseId:any
  courseData:any
  imageUrl=environment.apiUrls.course_imageUrl;


  constructor(public apiService:ApiService,private activatedroute:ActivatedRoute) {
    this.activatedroute.paramMap.subscribe(params => { 
      this.courseId = params.get('id'); 
    });
   }

  ngOnInit(): void {
   this.getCourseById()
}

  getCourseById(){
    this.apiService.getCourseById(this.courseId).subscribe((res:any)=>{
      this.courseData=res?.data[0]

    })
  }

}
